
import React from "react";
import { Modal2 } from "../../components/modal";
import {timestamp_to_time_str} from "../../../lib/time";
import { sprintf } from "sprintf-js";

const MessagePopup = props => {

  const msg = props.message;
  const username = props.username;

  const container_style = {
    width: "60rem",
  }
  const from_label = msg.from.name || msg.from.email;
  const to_label = msg.to.name || msg.to.email;
  const title = msg.from.username === username
    ? "To: " + to_label
    : "From: " + from_label;
  const date = new Date(msg.timestamp_ms);
  const date_str = sprintf("%s %s",
    date.toDateString(), timestamp_to_time_str(msg.timestamp_ms));

  const header_style = {
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    fontSize: "1.2rem",
    fontWeight: "600",
  }
  const header = (
    <div style={header_style}>
      <div style={{flex: "0 0 20rem"}}>
        <span>Subject: {msg.subject}</span>
      </div>
      <div style={{flex: "1"}}/>
      <div>
        { date_str }
      </div>
    </div>
  );

  const button_list = [
    {
      label: "Ok",
      cb: () => props.onClose(),
    }
  ]

  return (
    <Modal2
      container_style={container_style}
      show={true}
      header={header}
      buttonList={button_list}
      title={title}>
      <span>{msg.message}</span>
    </Modal2>
  )
};

export { MessagePopup };
